// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Ul-z","tupacHeader":"Vl-z","tupacHeader2":"Wl-z","tupacMenu":"Xl-z","tupacMenu2":"Yl-z","tupacMain":"Zl-z","tupacMain2":"_l-z"};